import Link from 'next/link';
import { ProposalCard } from '@/app/types/proposals';
import { formatDate } from '@/app/helpers/formatDate';
import { formatVotesValue } from '@/app/helpers/formatVotes';

interface ProposalsTableProps {
  proposals: ProposalCard[];
}

const ProposalsTable: React.FC<ProposalsTableProps> = ({ proposals }) => {
  if (proposals.length === 0) return <></>;

  return (
    <div className="mt-8 overflow-x-auto">
      <table className="w-full border-collapse">
        <thead>
          <tr className="text-left border-b border-neutral-700">
            <th className="py-4 px-6 text-yellow">Title</th>
            <th className="py-4 px-6 text-yellow">Status</th>
            <th className="py-4 px-6 text-yellow">Votes For</th>
            <th className="py-4 px-6 text-yellow">Votes Against</th>
            <th className="py-4 px-6 text-yellow text-right">Date</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-neutral-700">
          {proposals.map((proposal, index) => (
            <tr key={index} className="hover:bg-neutral-900 group">
              <td className="py-4 px-6">
                {proposal.proposal_id ===
                '37695651889739924036315130198910549192250601445193408333915933331571403831552' ? (
                  <span className="transition-colors">{proposal.title}</span>
                ) : (
                  <Link
                    href={`/karratco/view/proposal/${proposal.proposal_id}`}
                    className="hover:text-white transition-colors"
                  >
                    {proposal.title}
                  </Link>
                )}
              </td>
              <td className="py-4 px-6">
                <span
                  className={`px-2 rounded-full ${proposal.state.bgColor} ${proposal.state.textColor}`}
                >
                  {proposal.state.text}
                </span>
              </td>
              <td className="py-4 px-6 text-accent">
                {formatVotesValue(proposal.votes_for)}
              </td>
              <td className="py-4 px-6 text-defeated">
                {formatVotesValue(proposal.votes_against)}
              </td>
              <td className="py-4 px-6 text-right">
                {proposal.created_at ? (
                  formatDate(new Date(proposal.created_at))
                ) : (
                  <p>-</p>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProposalsTable;
